import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import { BodyLargeBold, HeadlineMedium } from "../../../components/font";

import Flex from "../../../layout/flex";
import PersonaReact from "persona-react";
import { Button } from "@manifesthhqinc/ui-library";

const IDVerificationPersona = (props: ConfirmTransferScreenProps) => {
  const { isMock, idVerificationObj, onFinishPersona } = props;
  if (isMock) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name="id-verification-start">
          <Container>
            <Flex $flexGap={8} $flexDirection="column">
              <HeadlineMedium $textAlign="center">Identity Verification</HeadlineMedium>
            </Flex>
            <Flex $flexGap={28} $flexDirection="column">
              <BodyLargeBold $textAlign="center">You are in Sandbox environment. </BodyLargeBold>
              <br />
              <Flex $flexGap={14} $flexDirection="column">
                <Button onClick={() => onFinishPersona("approved")} variant="secondary">
                  Mock Success
                </Button>

                <Button onClick={() => onFinishPersona("needs_review")} variant="secondary">
                  Mock Failed
                </Button>
              </Flex>
            </Flex>
          </Container>
        </ScrollableContainer>
      </TransitionWrapper>
    );
  }
  if (!idVerificationObj?.personaInquiryId) {
    return <></>;
  }
  return (
    <PersonaReact
      inquiryId={idVerificationObj?.personaInquiryId}
      frameAncestors={[
        "https://dev-bridge.dev-manifest.com", // our app
        "https://bridge.usemanifest.com",
      ]}
      onError={(e) => console.error("on Error", e)} // TODO: do something
      onComplete={({ status }) => {
        onFinishPersona(status);
      }}
    />
  );
};

export default IDVerificationPersona;
